module.exports = __webpack_public_path__ + "static/media/icon-booth-rev-insurance.44c1b218.svg";